"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _init = _interopRequireDefault(require("./init"));
var _listener = _interopRequireDefault(require("./listener"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function hotjar(hotjarId, snippetVersion) {
  return {
    init: (0, _init.default)(hotjarId, snippetVersion),
    listener: _listener.default
  };
}
var _default = hotjar;
exports.default = _default;